import VueRouter from 'vue-router';
import QueryString from 'qs';
import {
  Auth,
  Route,
  Dom,
  EventBus,
  Session,
} from '@intelipost-js/secure-providers';
import * as modulesRoutes from '../node_modules/@intelipost-modules/*/index.js'; //eslint-disable-line
import * as privateFeatures from './features/private/*/routes.js'; //eslint-disable-line
import * as publicFeatures from './features/public/**/routes.js'; //eslint-disable-line

import PageHome from './features/private/home/PageHome';

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    ...Route.convert(publicFeatures),
    {
      path: '/',
      name: 'home',
      component: PageHome,
      children: Route.convert({
        ...privateFeatures,
        ...modulesRoutes,
      }),
      meta: {
        requiresAuth: true,
      },
      redirect: {
        name: 'welcome',
      },
    },
  ],
  parseQuery(query) {
    return QueryString.parse(query);
  },
  stringifyQuery(query) {
    const result = QueryString.stringify(query);

    return result ? `?${result}` : '';
  },
});

router.beforeEach((to, from, next) => {
  document.title = Dom.formatPageTitle(to);

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuth = Auth.isAuth();

  Session.checkInactivity(requiresAuth);

  if (requiresAuth && !isAuth) {
    return next({
      name: 'login',
      query: { redirect: to.fullPath },
    });
  }

  if (!to.name && to.path) {
    return next({ path: `/ng#${to.path}` });
  }

  if (isAuth && to.name === 'login') {
    return next({ name: 'welcome' });
  }

  if (to.fullPath.indexOf('/quote-detail') > -1) {
    const id = to.fullPath.split('/').pop();

    return next({
      name: 'quotation',
      params: {
        id,
      },
    });
  }

  return next();
});

router.afterEach((to, from) => {
  if (from.name !== null && to.name === 'ng' && to.name !== from.name) {
    window.location.href = to.path;
  }

  Dom.scrollTo();
});

EventBus.$on('routerPush', (event) => {
  const { name = null, query = {} } = event;

  if (name === 'login') {
    Object.assign(event, {
      query: {
        ...query || {},
        redirect: router.history.current.fullPath,
      },
    });
  }

  router.push(event);
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js